import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { buscarIniciativas } from 'services/iniciativa.service';
import { HeaderElbb } from '../HomeElbb/components/Header';
import { HeroMinhasIniciativasElbb } from './components/HeroMinhasIniciativasElbb';
import { IniciativaDetalhadaElbb } from './components/IniciativaDetalhadaElbb';
import './style.scss';

export function MinhasIniciativasElbb() {
  const { user } = useAuth();
  const location = useLocation();
  const [iniciativas, setIniciativas] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  useEffect(() => {
    async function carregarMinhasIniciativas() {
      try {
        setLoading(true);
        const data = await buscarIniciativas({
          userId: user?._id,
          categoria: 'ELBB',
        });

        // Filtrar apenas iniciativas ELBB do usuário logado
        const minhasIniciativasElbb = data.filter(
          (ini: any) =>
            ini.categoryPremio === 'ELBB' &&
            (ini.cadastradoMatricula === user?._id ||
             ini.inscritoMatricula === user?._id ||
             ini.participantes?.some((p: any) => p.matricula === user?._id))
        );

        setIniciativas(minhasIniciativasElbb);
      } catch (error) {
        console.error('Erro ao carregar minhas iniciativas:', error);
        setIniciativas([]);
      } finally {
        setLoading(false);
      }
    }

    if (user?._id) {
      carregarMinhasIniciativas();
    }
  }, [user?._id]);

  return (
    <div id="minhas-iniciativas-elbb-wrapper">
      <HeaderElbb currentPage="minhas-iniciativas" />

      <HeroMinhasIniciativasElbb />

      <main className="minhas-iniciativas-elbb-main">
        <div className="minhas-iniciativas-elbb-main__container">
          <h2 className="minhas-iniciativas-elbb-main__section-title" tabIndex={0}>
            Iniciativas inscritas
          </h2>

          <p className="minhas-iniciativas-elbb-main__count" tabIndex={0} aria-live="polite">
            {loading ? 'Carregando...' : `${iniciativas.length} inscrita${iniciativas.length !== 1 ? 's' : ''}`}
          </p>

          {loading ? (
            <div className="minhas-iniciativas-elbb-main__loading" role="status" aria-live="polite">
              <span>Carregando iniciativas...</span>
            </div>
          ) : iniciativas.length === 0 ? (
            <div className="minhas-iniciativas-elbb-main__empty" role="status">
              <p className="minhas-iniciativas-elbb-main__empty-title" tabIndex={0}>
                Você ainda não possui iniciativas inscritas.
              </p>
              <p className="minhas-iniciativas-elbb-main__empty-subtitle" tabIndex={0}>
                Cadastre suas iniciativas para acompanhá-las aqui!
              </p>
            </div>
          ) : (
            <div className="minhas-iniciativas-elbb-main__list" role="list" aria-label="Suas iniciativas inscritas">
              {iniciativas.map((iniciativa) => (
                <IniciativaDetalhadaElbb
                  key={iniciativa.id}
                  iniciativa={iniciativa}
                />
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
